'use client';

import { SignInButton } from '@clerk/nextjs';
import { LogIn, ArrowLeft } from 'lucide-react';
import Link from 'next/link';

export default function LoginPrompt() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <div className="mx-auto w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
            <LogIn className="w-8 h-8 text-indigo-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Iniciar Sesión
          </h1>
          <p className="text-gray-600">
            Debes iniciar sesión para acceder al panel de autogestión de revendedores
          </p>
        </div>

        <div className="space-y-4">
          <SignInButton mode="modal">
            <button className="w-full flex items-center justify-center px-6 py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors">
              <LogIn className="w-5 h-5 mr-2" />
              Iniciar Sesión
            </button>
          </SignInButton>

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">o</span>
            </div>
          </div>

          <Link
            href="/revendedores"
            className="w-full flex items-center justify-center px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Volver a Revendedores
          </Link>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-600 text-center">
            ¿No tienes una cuenta?{' '}
            <Link href="/contacto" className="text-indigo-600 hover:text-indigo-700 font-medium">
              Contáctanos
            </Link>{' '}
            para convertirte en revendedor autorizado
          </p>
        </div>
      </div>
    </div>
  );
}
